<app-send-invoice [invoice]="invoice" (invoiceSent)="dialogRef.close()"  (invoiceSendCancelled)="dialogRef.close()" [contextIdDto]="contextIdDto" [eventBus]="eventBus" [visible]="true"></app-send-invoice>

